<script setup>
// Contants declarations
const attrs = useAttrs()

// Component props
const props = defineProps({
  logoSize: {
    type: String,
    required: false,
    default: 'large',
  },
  mobile: {
    type: Boolean,
    default: false,
    required: true,
  },
  miniStateOverwrite: {
    type: Boolean,
    required: false,
    default: false,
  },
  transparentBackground: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <q-img
    no-spinner
    v-if="logoSize === 'large' || miniStateOverwrite"
    src="/logos/new-logo.png"
    class="header omni-logo"
    :class="{ 'mobile-logo': mobile || !$q.screen.gt.sm, 'transparent-logo': transparentBackground }"
    v-bind="$attrs"
  />
  <q-img
    no-spinner
    v-if="logoSize === 'small' && !miniStateOverwrite"
    src="/logos/new-logo-smaller.png"
    class="header omni-logo"
    :class="{ 'mobile-logo': mobile || !$q.screen.gt.sm, 'small-logo': !mobile || $q.screen.gt.sm, 'transparent-logo': transparentBackground }"
    v-bind="$attrs"
  />
</template>

<style scoped>
.transparent-logo {
  background-color: transparent !important;
}
</style>
